import React from 'react';
import { Data, LetterTypes } from '../types';
import DeclineLetterContent from './DeclineLetterContent';
import OtafLetterContent from './OtafLetterContent';
import OtafSamePriceLetterContent from './OtafSamePriceLetterContent';
import ReinstatementApprovalContent from './ReinstatementApprovalContent';
import ReinstatementDeclineContent from './ReinstatementDeclineContent';
import ReinstatementWithdrawalContent from './ReinstatementWithdrawalContent';
import SubstandardLetterContent from './SubstandardLetterContent';
import WithdrawalLetterContent from './WithdrawalLetterContent';

export interface LetterContentProps {
  data: Data;
}

const LetterContent = ({ data }: LetterContentProps) => {
  if (!data.source) {
    switch (data.letterType) {
      case LetterTypes.substandard:
        return (
          <SubstandardLetterContent
            carrier={data.carrier}
            isJuvenile={data.isJuvenile}
          />
        );
      case LetterTypes.reinstatementApproval:
        return <ReinstatementApprovalContent carrier={data.carrier} />;
      case LetterTypes.reinstatementWithdrawal:
        return <ReinstatementWithdrawalContent carrier={data.carrier} />;
      default:
        return null;
    }
  }

  switch (data.letterType) {
    case LetterTypes.decline:
      return (
        <DeclineLetterContent
          carrier={data.carrier}
          source={data.source}
          formData={data.letter}
          isJuvenile={data.isJuvenile}
        />
      );
    case LetterTypes.otaf:
      return (
        <OtafLetterContent
          carrier={data.carrier}
          source={data.source}
          formData={data.letter}
          riders={data.riders}
          isJuvenile={data.isJuvenile}
        />
      );
    case LetterTypes.withdrawal:
      return (
        <WithdrawalLetterContent
          carrier={data.carrier}
          source={data.source}
          formData={data.letter}
          isJuvenile={data.isJuvenile}
        />
      );
    case LetterTypes.otafSamePrice:
      return (
        <OtafSamePriceLetterContent
          carrier={data.carrier}
          source={data.source}
          formData={data.letter}
          riders={data.riders}
        />
      );
    case LetterTypes.reinstatementDecline:
      return (
        <ReinstatementDeclineContent
          carrier={data.carrier}
          source={data.source}
          formData={data.letter}
        />
      );
    default:
      return null;
  }
};

export default LetterContent;
